import "./App.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { useRoutes } from "react-router-dom";
import HomePage from "./pages/Home";
import TheNeedPage from "./pages/TheNeed";
import ApproachPage from "./pages/Approach";
import FreeCoursesPage from "./pages/FreeCourses";
import CollaborationsPage from "./pages/Collaborations";
import ServicesPage from "./pages/Services";
import DonationsPage from "./pages/Donations";
import UpdatesPage from "./pages/Updates";
import ContactPage from "./pages/Contact";

function App() {
  const routes = useRoutes([
    { path: "/", element: <HomePage /> },
    { path: "/the-need", element: <TheNeedPage /> },
    { path: "/approach", element: <ApproachPage /> },
    { path: "/free-courses", element: <FreeCoursesPage /> },
    { path: "/collaborations", element: <CollaborationsPage /> },
    { path: "/services", element: <ServicesPage /> },
    { path: "/donations", element: <DonationsPage /> },
    { path: "/updates", element: <UpdatesPage /> },
    { path: "/contact", element: <ContactPage /> },
  ]);
  return (
    <div className="overflow-x-hidden">
      <Navbar />
      {routes}
      <Footer />
    </div>
  );
}

export default App;
